import type { DisableStreamRequest, LocationStream } from '@/domain/videoStream';

import type { LocationVideoState } from './locationVideoStore';

interface LocationStreamActions
    extends Pick<LocationVideoState, 'updateMuxData' | 'buttonActionHandler'> {
    disableStream: (request: DisableStreamRequest) => unknown;
}

/**
 * Seeds the store from the location's stream list: disables streams that lost their
 * connection, records each stream's state and selects the pens already streaming.
 */
export function applyLocationStreams(
    locationStreams: LocationStream[],
    actions: LocationStreamActions
): void {
    const { disableStream, updateMuxData, buttonActionHandler } = actions;

    if (locationStreams) {
        const cagesArray = locationStreams;
        for (const cage of cagesArray) {
            if (cage.stream?.status === 'disconnected') {
                disableStream({ bioscopeId: cage.bioscopeId });
            }
        }
    }

    if (locationStreams.length > 0) {
        for (let i = 0; i < locationStreams.length; i++) {
            const bioscope = locationStreams[i];
            const stream = bioscope.stream;

            stream &&
                updateMuxData(stream.bioscope_id, {
                    streamId: stream.mux_stream_id,
                    status: stream.status,
                    timestamp: stream.timestamp,
                    userId: stream.started_by_user_id || null,
                    playbackId: stream.playback_id || null,
                });

            if (stream?.status === 'active') {
                buttonActionHandler(stream.bioscope_id, true);
            }
        }
    }
}
